module.exports = __webpack_public_path__ + "static/favicon-42b2780b062677d7580e3264a95ee640.ico";